import api from './axiosClient'
import { GetAllGlobalNotificationResponseProto, GlobalNotificationProto } from '../../proto/generated/global-notification'

export const handleGetAllActiveGlobalNotifications = async (): Promise<GlobalNotificationProto[]> => {
    return new Promise((resolve, reject) => {
        const url = `/global-notification`;
        api.get(url, {
            headers: { 'Accept': 'application/x-protobuf' },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const decodedData = GetAllGlobalNotificationResponseProto.decode(new Uint8Array(response.data));
                if (decodedData.globalNotificationProto) {
                    resolve(decodedData.globalNotificationProto);
                } else {
                    resolve([]);
                }
            })
            .catch((error) => {
                console.error("Failed", error);
                reject(error);
            });
    });
};

